import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const InfoCard = styled('div')`
  background: var(--dk-bg, #ffffff);
  border: 1px solid var(--dk-line, #e7e9ec);
  border-radius: 8px;
  overflow: hidden;
`;

export const InfoRow = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  font-size: 14px;
  line-height: 20px;

  &:not(:last-of-type) {
    border-bottom: 1px solid var(--dk-line, #e7e9ec);
  }
`;

export const InfoLabel = styled('span')`
  width: 80px;
  color: var(--dk-text-secondary, #888d96);
  flex-shrink: 0;
`;

export const InfoValue = styled('span')`
  color: var(--dk-text, #000000);
  font-weight: 500;
`;

export const DownloadButton = styled('button')`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 14px;
  background: var(--dk-inverse-bg, #000000);
  color: var(--dk-inverse-text, #ffffff);
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  cursor: pointer;

  &:active {
    opacity: 0.8;
  }
`;

export const Section = styled(Stack)`
  padding: 0 20px;
`;
